// import {React,useState}from 'react';
import NavBarV2 from "../../NavBarV2";
import React, { useEffect, useState,useRef  } from "react";
import Button from "@mui/material/Button";
import "../../../WorkSpace/font.css";
import "../../Workspace2/sidebar.css";
import {
    VerifyOtp,
    cities,
    country,
    getTrialBalance,
    signupV2,
    state,
} from "../ApiServices/apiHandler";
import swal from "sweetalert";
import { useLocation } from "react-router";
import accountant from "../../../assets/signIn.svg";
import signInCss from "../../../myfin_v2/css/signIn.module.css"
import commoncss from "../../../myfin_v2/css/common.module.css"
import buttoncss from "../../../myfin_v2/css/button.module.css"
import OtpInput from "../../../myfin_v2/elements/OtpInput";
import { ReactComponent as MyFinLogo } from "../../../myfin_v2/assets/icons/myfinLogo.svg"

const Validation = (props) => {
    const location = useLocation();
    let a = location.pathname;
    let w_id = a.split("/");
    const [error, seterror] = useState({
        org_name: true,
        email: true,
        password: true,
        confirmPwd: true,
    });
    const [Value, setValue] = useState("");
    const [otp, setOtp] = useState(Array(6).fill(""));
    const inputsRef = useRef([]);
    useEffect(() => { }, []);

    function handleChange(value, index) {
        setValue(value);
    }

    const handleKeyDown = (e, index) => {
        if (e.key === "Backspace" && !otp[index] && index > 0) {
            inputsRef.current[index - 1].focus();
        }
    };

    const handleVerify = async () => {
        try{

            let data = {
                otp: Value,
                user_id: w_id[2],
            };
            
            const result = await VerifyOtp(data);
            if (result.status === 200) {
                // localStorage.setItem("auth_token", result.data.token);
                props.history.push("/");
                // window.location.reload();
            } else {
                // swal("", "Wrong OTP", "danger");
                swal("", "Invalid OTP", "error");
    
            }
        } catch (error) {
            swal("Invalid OTP", "", "error");
        }
    };

    return (
        <div className="conatiner">
            <div className={signInCss.imgContainer}>
                <img src={accountant} alt="accountant working" style={{
                    "height": "93.7vh", "place-self": "center"
                }}></img>
            </div>
            <div className={signInCss.formContainer}>
                <div
                    className={commoncss.dFlexJustifysb}

                >
                    <div className={commoncss.dFlex}>
                        <div className={commoncss.dFlexClm}>
                            <span className={signInCss.heading1}>
                                Hello there!
                            </span>
                            <span className={signInCss.label1}>
                                Password Reset in Progress
                            </span>
                        </div>
                    </div>
                    <div>
                        <MyFinLogo />
                    </div>
                </div>
                <div className={signInCss.container2}>

                    <label className={signInCss.headerText}>Enter the OTP sent to your email</label>
                    <div className={`${signInCss.container3} mt-4`} style={{ width:"43%" }}>
                        
                        <OtpInput length={6} onChange={(val) => setValue(val)} />

                        <div className="w-100 mt-4">
                            <button onClick={handleVerify} className={buttoncss.primary} style={{ "padding": "7px", "width": "100%", "border-radius": "12px" }}>Verify OTP</button>
                        </div>
                        
                    </div>
                    <div
                        className={`w-100 ${signInCss.tnc}`}
                    >
                        <span>
                            <span className={signInCss.label1}>By joining, you agree to the</span><span className={signInCss.label2}>Terms and Privacy Policy</span>
                        </span>
                    </div>
                </div>
            </div>
        </div>
    );

    // return (
    //   <div style={{ backgroundColor: "#f5f5f5" }}>
    //     <NavBarV2 />
    //     <div style={{ marginTop: "90px" }}>
    //       <center>
    //         <h1>
    //           <h3 className="fs-inter db-v2-head">Validate Your OTP!</h3>
    //         </h1>
    //         <p className="dm-sans dbv2-dhead">
    //           With MyFinalyst, you can easily create and audit financial
    //           <br />
    //           statements for your company or clients.
    //         </p>
    //       </center>

    //       <div className="input_box">
    //         <div
    //           className="password-signin"
    //           style={{
    //             display: "flex",
    //             flexDirection: "column",
    //             color: "#696F79",
    //           }}
    //         >
    //           <strong>Enter your OTP</strong>
    //           <input
    //             name="org_name"
    //             type="text"
    //             onChange={(e) => handleChange("otp", e.target.value)}
    //           />
    //         </div>
    //         <Button
    //           style={{
    //             backgroundColor: "#03565A",
    //             color: "white",
    //             height: "65px",
    //             width: "100%",
    //             marginTop: "30px",
    //             fontSize: "20px",
    //           }}
    //           onClick={handleVerify}
    //         >
    //           Verify OTP
    //         </Button>
    //       </div>
    //     </div>
    //   </div>
    // );
};

export default Validation;
